import React from 'react'

import DashBoard from '../../../components/management/sales/index'
import ContainerPages from '../../ContainerPages'

export default function Container(props: any) {
  return <ContainerPages component={DashBoard} />
}
